import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { renderField } from '../../../lib/helper/form';
import { connect } from 'react-redux';
import { patientListSetFilters, patientListClearFilters, patientListSetPage } from '../../../lib/redux/actions/patients';
import Form from 'react-bootstrap/Form';
import { getFiltersFromSession } from '../../../lib/routing/filters';
import { applyPatientFilters, patientInitialValues } from '../../../lib/helper/patientFilters';
import ConsultantTypeahead from '../../fields/ConsultantTypeahead';

/**
 * MED-921 - the three searches the patient index offers.
 *
 * One name box rather than separate forename and surname fields, because a member of staff
 * looking someone up types the name they have. The API's `name` filter requires every word to
 * match one of the two columns, so "Norah Halloway", "Halloway", "Norah" and "Hall" all work.
 *
 * The date of birth is one field meaning "born on this day", not a range - it is the thing that
 * separates the 1,091 shared names in this register. applyPatientFilters turns it into the
 * single-day range the API needs.
 *
 * The consultant filter reaches through the patient's invoices, since `Patient` carries no
 * consultant of its own. The typeahead's selection lives in component state rather than in the
 * redux-form values, which is how InvoiceTableFilterForm handles the same field.
 */
const mapStateToProps = (state, ownProps) => {
  const { location } = ownProps;

  return {
    initialValues: patientInitialValues(getFiltersFromSession(location, 'json')),
    ...state.patients,
  };
};

const mapDispatchToProps = {
  patientListSetPage,
  patientListSetFilters,
  patientListClearFilters,
};

class PatientTableFilterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedConsultants: [],
      isLoadingConsultants: false,
      clearTypeaheads: false,
    };
  }

  onSubmit(values) {
    const { location } = this.props;
    this.props.patientListSetPage(1);
    this.props.patientListSetFilters(applyPatientFilters(values, this.state.selectedConsultants), location);
  }

  typeaheadCleared() {
    this.setState({ clearTypeaheads: false });
  }

  resetFilters() {
    const { reset, patientListClearFilters, patientListSetPage, location } = this.props;
    patientListSetPage(1);
    patientListClearFilters(location);
    // Reset has to clear the typeahead too, or the box still shows a consultant that is no
    // longer being filtered on.
    this.setState({ selectedConsultants: [], clearTypeaheads: true });
    reset();
  }

  render() {
    const { handleSubmit, error } = this.props;

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="form-inline form-data-filters">
          <Field name="name" label="Name" type="text" component={renderField} />
          <Field name="dob" label="Date of Birth" type="date" component={renderField} />

          <ConsultantTypeahead
            label="Consultant"
            shouldClear={this.state.clearTypeaheads}
            hasCleared={this.typeaheadCleared.bind(this)}
            selectedConsultants={this.state.selectedConsultants}
            isLoading={this.state.isLoadingConsultants}
            onChange={(selected) => {
              this.setState({ selectedConsultants: selected, isLoadingConsultants: false });
            }}
          />

          <div className="filter-actions">
            <button type="submit" className="btn btn-primary btn-sm">
              Filter
            </button>
            <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
              Reset
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'PatientTableFilterForm',
    enableReinitialize: true,
  })(PatientTableFilterForm),
);
